<template>
    <div>
        <header>
            <img src="../assets/notros.png" alt="" width="55">
            <ul>
                <li><router-link to="satari">Satari</router-link></li>
                <li><router-link to="offers">Ofertas</router-link></li>
                
            </ul>
            <div class="profile">
                <img src="../assets/notros.png" alt="" width="55">
            </div>
        </header>
    </div>
</template>

<script>
export default {
    name : 'Navbar'
}
</script>

<style lang="sass">
header img
    height: 60px
    margin-left: 40px

body
    height: 125vh
    background-size: cover
    font-family: sans-serif
    margin-top: 80px
    padding: 30px

main
    color: white

header
    background-color: $secondary
    position: fixed
    top: 0
    left: 0
    right: 0
    height: 60px
    display: flex
    align-items: center
    box-shadow: 0 0 5px 0 black
    font-family: 'Roboto'
    font-weight: 300
    font-size: 15px

header *
    display: inline

header li
    margin: 20px

header li a
    color: white
    text-decoration: none

header.profile
    float: right
</style>
